import { fetchData, postData } from "../../../Services/GlobalService";
import type { ConstructType } from "./Construct";
import { downloadExcelDateFormat } from "../../../Services/GlobalFunction/DownLoadExcel";
import { toast } from "react-toastify";
import { AxiosExcel } from "../../../API/Axios";

const Controller = "ConstructDBSIP";

export type TabName = "TargetSettings" | "ProdCapping";
export interface UploadApiResponse {
  status: "success" | "warning" | "error";
  message: string;
  data: Record<string, unknown>[] | null;
}

export interface UploadResult {
  outcome: "uploaded" | "warning" | "error";
  message: string;
  errorRows: Record<string, unknown>[] | null;
}

export const uploadTabData = async (params: {
  paramId: number;
  constructSeq: number | null;
  constructType: ConstructType;
  file: File;
  userId: string;
  tabname:string;
}): Promise<UploadResult> => {
  try {
    
    const formData = new FormData();
    formData.append("Pvc_Stream", params.constructType);
    formData.append("CONSTRUCTSEQ", String(params.constructSeq ?? ""));
    formData.append("PARAMETERSEQ", String(params.paramId));
    formData.append("FileContent", params.file);
    formData.append("Pvc_UserID", params.userId);

    const res = await AxiosExcel.post(
      `${Controller}/${params.tabname === "ProdCapping" ? "SaveBrandCappingUpload" : "SaveTargetUploadMap"}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    if (res?.data.Status === "Warning") {
      return { outcome: "warning", message: res.data.Message, errorRows: null };
    }

    if (res?.data.Status === "Error") {
      const errorRows =
        Array.isArray(res.data.Data) && res.data.Data.length > 0 ? res.data.Data : null;
      return {
        outcome: "error",
        message:
          res.data.Message || "Upload failed. Please check the error file.",
        errorRows,
      };
    }

    // "success"
    return { outcome: "uploaded", message: res.data.Message, errorRows: null };
  } catch (err) {
    console.error("File Upload API failed:", err);
    return {
      outcome: "error",
      message: "Upload failed due to a network error. Please try again.",
      errorRows: null,
    };
  }
};

export const downloadTabData = async (params: {
  tabName: TabName;
  paramId: number;
  parameterName: string;
  constructSeq: number | null;
  constructType: ConstructType;
}): Promise<void> => {
  try {
    const res = await fetchData(
      Controller,
      params.tabName === "ProdCapping" ? "GetCappingDataDownload" : "GetDownLoadTargetData",
      `STREAM_CODE=${
        params.constructType
      }&CONSTRUCT_SEQ=${params.constructSeq}&PARAM_SEQ=${params.paramId}`,
    );

    if (res?.Data?.length > 0) {
      downloadExcelDateFormat(res.Data, `${params.parameterName}_${params.tabName}.xlsx`);
      return;
    } else {
      toast.warn("No data Found");
    }
  } catch {}
};

export const downloadTabTemplate = async (params: {
  tabName: TabName;
  paramId: number;
  parameterName: string;
  constructType: ConstructType;
}): Promise<void> => {
  try {
    const res = await fetchData(
      Controller,
      params.tabName === "ProdCapping" ? "DownLoadBrandCappingTemplate" : "DownLoadTargetTemplate",
      `StreamCode=${params.constructType}&strParameterSeqID=${params.paramId}`,
    );

    if (res?.Data?.length > 0) {
      downloadExcelDateFormat(
        res.Data,
        `${params.parameterName}_${params.tabName}_template.xlsx`,
      );
    } else {
      toast.warn("No data Found");
    }
  } catch {}
};
